import React from 'react';
import {Table} from '../../../components/table/Table';
import {useNavigation} from '@react-navigation/native';

export const OrganizationCategoryTable = () => {
  const navigation = useNavigation();
  return (
    <Table
      eventSourceId="OrganizationCategory"
      api={`/organizationcategories`}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`update-organization-category`, {row});
      }}
      columns={[
        {
          type: 'text',
          field: 'name',
          header: 'Name',
        },
        {
          type: 'text',
          field: 'score',
          header: 'Score',
        },
      ]}
    />
  );
};
